"use strict";

var _classCallCheck = require("/home/jj/rep/arboreal/js/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jj/rep/arboreal/js/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/jj/rep/arboreal/js/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/jj/rep/arboreal/js/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/jj/rep/arboreal/js/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Button =
/*#__PURE__*/
function (_react$default$Compon) {
  _inherits(Button, _react$default$Compon);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      return (
        /*#__PURE__*/
        _react.default.createElement("button", {
          style: {
            border: '1px solid black',
            borderRadius: 10,
            padding: "5px 10px 5px 10px",
            cursor: "pointer",
            outline: "none"
          },
          onClick: this.props.function
        },
        /*#__PURE__*/
        _react.default.createElement("span", {
          style: {
            fontSize: 14,
            fontWeight: 500
          }
        }, " ", this.props.text, " "))
      );
    }
  }]);

  return Button;
}(_react.default.Component);

exports.default = Button;